export const BASE_URL = 'https://api.github.com/users/';
